<template>
	<div>
		<Dialog
			v-bind:value="value"
			@input="$emit('input', $event)"
			title="Bitte anmelden"
			:hide-buttons="true" persistent>
			<v-tabs
				v-model="tab"
				:color="ada.pink"
				show-arrows
			>
				<v-tabs-slider :color="ada.pink"></v-tabs-slider>
				<v-tab
					v-for="item in items"
					:key="item">
					{{ item }}
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab">
				<!-- Interner Zugang -->
				<v-tab-item>
					<v-card flat>
						<v-card-text>
							Sollten Sie diese Meldung nach dem Login per SSO immer noch sehen, konnte kein lokaler
							Nutzer
							gefunden werden. Bitte wenden Sie sich an den Systemadministrator.
							<Button :color="ada.pink" class="mt-6 mx-auto d-block" @click="redirectToSso">Anmelden per
								Ad
								Alliance SSO
							</Button>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<!-- Externer Zugang -->
				<v-tab-item>
					<v-card flat>
						<v-card-text>
							<v-alert
								outlined
								type="warning"
								border="left"
							>
								Bitte beachten, dass der Zugang nur aus einem freigeschalteten Netzwerk möglich ist.
							</v-alert>
							<Input v-model="externalCode" label="Zugangscode"></Input>
							<Button :color="ada.pink" class="mx-auto d-block" :loading="loading">Anmelden</Button>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</Dialog>
		<Snackbar v-model="snackbar" :color="snackbar_type">{{ snackbar_message }}</Snackbar>
	</div>
</template>

<script>
import Dialog from "../components/Dialog";
import ada from "../scss/ada_colors.scss";
import Button from "../components/buttons/Button";
import Input from "../components/Inputs/Input";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import Snackbar from "../components/Snackbar";

export default {
	name: "LogInDialog",
	components: {Snackbar, Input, Button, Dialog},
	props: ['value'],
	mixins: [validationMixin],
	validations: {
		externalCode: {required},
	},
	data: () => {
		return {
			tab: false,
			items: ["Interner Zugang", "Externer Zugang"],
			externalCode: null,
			loading: false,
			snackbar: false,
			snackbar_type: 'success',
			snackbar_message: null,
			ada
		}
	},
	computed: {
		ssoResponse() {
			return this.$store.state.ssoLoginRes;
		}
	},
	methods: {
		redirectToSso() {
			console.log('ssoResponse', this.ssoResponse);
			window.location.href = this.ssoResponse.url + '&redirect=' + encodeURIComponent(location.origin + location.pathname + location.hash.split('?')[0]);
		},
		async submit() {
			try {
				let data = await this.$store.dispatch('externalLogin', {ExternalCode: this.externalCode});
				this.loading = false;
				if (!data.notAllowed) {
					this.showSaveChangesDialog = false;
				} else {
					this.activateSnackbar('Anmeldung fehlgeschlagen.', true);
				}
			} catch (e) {
				this.loading = false;
			}
		},
		activateSnackbar(msg, error = false) {
			this.$root.$emit('snackbar', msg, error ? 'error' : 'success');
		},
	}
}
</script>

<style scoped>

</style>